import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface AdviceMedia {
  id: number;
  src: string;
  mediaType: string; // IMAGE, VIDEO
}

export interface Advice {
  id: number;
  description: string;
  customInterval: boolean;
  interval: number;
  media?: AdviceMedia;
  mediaHorizontal?: AdviceMedia | null;
  mediaVertical?: AdviceMedia | null;
  promotion?: {
    id: number;
    connectorCta?: string | null;
  };
  company?: {
    id: number;
    name: string;
  };
}

@Injectable({
  providedIn: 'root'
})
export class AdviceService {
  private apiUrl = `${environment.apiUrl}/advices`;

  constructor(private http: HttpClient) { }

  /**
   * Obtiene los anuncios públicos de una empresa que tengan promoción
   */
  getPublicAdvicesByCompany(companyId: number): Observable<Advice[]> {
    return this.http.get<Advice[]>(`${this.apiUrl}/public/company/${companyId}`);
  }
}
